import { render, staticRenderFns } from "./regisTree.vue?vue&type=template&id=a29d5f58&scoped=true&"
import script from "./regisTree.vue?vue&type=script&lang=js&"
export * from "./regisTree.vue?vue&type=script&lang=js&"
import style0 from "./regisTree.vue?vue&type=style&index=0&id=a29d5f58&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a29d5f58",
  null
  
)

export default component.exports